


































































































































































































































































































































































































































































































































































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import AlertBox from '../../core/components/AlertBox.vue';
import $ from 'jquery';
import {
    getUniqueId,
    getHourFromTimestamp,
    formatDate,
    splitStringByIndex,
    getMaxDateFromList,
    parseFloatNumber,
    getCurrentTimestamp,
    openTravelWithParameter,
    getJsonObjectWithoutSomeKeys,
    booleanFormatter,
    itemsPerPageOptionsTable,
    ColorsList,
    getAlertColorByPriority
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    MsgBox,
    SimpleTable,
    Button,
    Combobox,
    Input,
} from '../../core/components';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import HourSelector from '../../core/components/HourSelector.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import { checkOverlapPeriod, differenceBetweenTwoDatesIsValid, valueIsEmpty } from '../../core/utils/validations';
import { Calibration, CalibrationPass, CalibrationSimulated, ComboSelectedOption, DateTimeField, dateTypes, defaultSelectedOption, selectedComboIdString, selectedOptionWithDescription } from '../../core/models';
import vColumnsResizable from '../../../plugins/vue-columns-resizable'
import { getNumberFormat, getStringValueFromCombobox } from '../../core/api/ValuesHelper';
@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: {
        Loading,
        SimpleTable,
        Combobox,
        Button,
        DatePickerSingle,
        HourSelector,
        Input,
        AlertBox
    }
})
export default class ModalVehicleCalibration extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() patchData: object | null;
    @Prop({ default: false }) saveOnMemory: boolean;
    @Prop() visible: boolean;
    @Prop() vehicleVin: number;
    @Prop() vehicleID: number;
    @Prop() variablesEnabled: any;
    @Prop({default(){return []}}) calibrations: any;
    @Prop() cropTypes: Array<object>;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    @Prop({
        default() {
            return [];
        }
    })
    companies: Array<object>;
    calibrationOptions: Array<object> = [];
    orangeColor: string = ColorsList.orange;
    modalTitle: string = '';
    operator: string = '';
    weightCalibrationFactorOriginal: number = 0;
    weightCalibrationFactor: string = '';
    humidityCalibrationFactor: string = '';
    areaValue: string = '';
    errorMsg: string = '';
    cropTypeValue: ComboSelectedOption = null;
    dateSelected: any = null;
    cropTypeSelected: any = null;
    cropTypeRV: boolean = false;
    calibrationFunctionSelectedRV: boolean = false;
    manuallyChecked: boolean = false;
    withoutTelemetry: boolean = false;
    workWidthValue: any = '';
    calibrationFunctionSelected: selectedComboIdString | null = null;
    comments: string = '';
    humiditySelected: selectedOptionWithDescription | null = null;
    humidityRV: boolean = false;
    decalibrate: boolean = false;
    weightVariable: selectedOptionWithDescription | null = null;
    weightVariableRV: boolean = false;
    loadingPasadas: boolean = false;
    defaultDelay: number = 0;
    delay: any = '';
    waitingPasada: boolean = false;
    firstTab: string = 'select_info';
    itemsPasadas: Array<object> = [];
    headersPasadas: Array<object> = [
        {
            text: 'Humedad (máq) (%)',
            align: 'center',
            value: 'measured_humidity',
             width: '80px',
            class: 'pa-0'
        },
        {
            text: 'Humedad (med) (%)',
            align: 'center',
            value: 'humidity',
            width: '80px',
            class: 'pa-0'
        },
        {
            text: 'Peso (máq) (Ton)',
            align: 'center',
            value: 'measured_weight',
            width: '80px',
            class: 'pa-0'
        },
        {
            text: 'Peso (med) (Ton)',
            align: 'center',
            value: 'weight',
            width: '80px',
            class: 'pa-0'
        },
        {
            text: 'Rinde (máq) (Ton/Ha)',
            align: 'center',
            value: 'rinde_maquina',
            class: 'pa-0'
        },
        {
            text: 'Rinde (med) (Ton/Ha)',
            align: 'center',
            value: 'rinde_medido',
            class: 'pa-0'
        },
        {
            text: 'Factor Rinde',
            align: 'center',
            value: 'performance_calibration_factor',
            class: 'pa-0'
        },
        {
            text: 'Factor Humedad',
            align: 'center',
            value: 'humidity_calibration_factor',
            class: 'pa-0'
        },
        {
            text: 'Area (Has)',
            align: 'left',
            value: 'area',
            width: '75px',
            class: 'pa-0'
        },
        {
            text: '¿Calibrar Humedad?',
            align: 'center',
            value: 'humidity_enabled',
        },
        {
            text: '¿Calibrar Peso?',
            align: 'center',
            value: 'weight_enabled',
        },
        {
            text: 'Fecha Inicio',
            align: 'center',
            value: 'start_date',
            width: '250px'
        },
        {
            text: 'Fecha Fin',
            align: 'center',
            value: 'end_date',
            width: '250px'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            width: '130px'
        }
    ];
    defaultItem: object = {};
    editedItem: object = {
        id: 0,
        humidity: 2,
        weight: 2,
        measured_humidity: 0,
        rinde_maquina: 0,
        rinde_medido: 0,
        humidity_enabled: false,
        weight_enabled: false,
        performance_calibration_factor: 0,
        humidity_calibration_factor: 0,
        calculated_weight: 0,
        measured_weight: 0,
        start_date: '',
        end_date: '',
        hour_start: '',
        hour_end: '',
        area: 2
    };
    editedIndex: number = -1;
    pasadasHumidity: string = '';
    pasadasMeasuredHumidity: string = '';
    pasadasMeasuredWeight: string = '';
    pasadasHumidityEnabled: boolean = false;
    pasadasWeightEnabled: boolean = false;
    pasadasWeight: string = '';
    pasadasCalculatedWeight: string = '';
    pasadasArea: string = '';
    pasadasStartDate: string = '';
    pasadasEndDate: string = '';
    pasadasStartHour: string = '';
    pasadasEndHour: string = '';
    calibrationHour: string = '';
    cropTypeRv: boolean = false;
    sortByPasadas: string[] = ['start_date'];
    sortDescPasadas: boolean[] = [true];
    calibrationsTypes: object = {
        multiplicador: 'performance_multiplier',
        desdeContador: 'accumulative_weight_counter_calculation',
        flujo: 'flow_delay_calculation'
    };

    pasadasItemClass(item){
        return !item.active_calibration_pass ? 'bg-light-orange' : '';
    }

    toggleApplyValueForPasada(item: CalibrationPass){
        let currentActiveValue = item['active_calibration_pass'];
        let newActiveValue = !currentActiveValue;
        if(this.editedIndex !== -1){
            this.editedItem['active_calibration_pass'] = newActiveValue
        }
        let index = this.itemsPasadas.findIndex(it => it['id'] === item.id);
        
        this.$set(this.itemsPasadas[index], 'active_calibration_pass', newActiveValue);
    }

    observablePasadasHumidityEnabled(){
        if(!this.pasadasHumidityEnabled){
            this.editedItem['measured_humidity'] = '';
            this.editedItem['humidity'] = '';
            this.itemsPasadas[this.editedIndex]['measured_humidity'] = '';
            this.pasadasMeasuredHumidity = '';
            this.pasadasHumidity = '';
            this.itemsPasadas[this.editedIndex]['humidity'] = '';
        }
    }
    observablePasadasWeightEnabled(){
        if(!this.pasadasWeightEnabled){
            this.editedItem['measured_weight'] = '';
            this.editedItem['weight'] = '';
            this.itemsPasadas[this.editedIndex]['measured_weight'] = '';
            this.pasadasMeasuredWeight = '';
            this.pasadasWeight = '';
            this.itemsPasadas[this.editedIndex]['weight'] = '';
        }
    }

    get getAlertColor() {
        return getAlertColorByPriority();
    }

    boolFormat(value){
        return booleanFormatter(value)
    }

    updateCropTypeSelectedRV(newName) {
        this.cropTypeRv = newName;
    }

    @Watch('withoutTelemetry')
    observableWithoutTelemetryField(value) {
        if (value) {
            this.updateHumidity(null);
            this.updateWeightVariable(null);
        } else {
            if (!this.isPatch) {
                this.updateFunctionSelected(null);
            }
        }
    }

    updatePasadasHourStart(value) {
        this.pasadasStartHour = value;
    }
    updateCalibrationHour(value) {
        this.calibrationHour = value;
    }
    updatePasadasHourEnd(value) {
        this.pasadasEndHour = value;
    }
    updatePasadasStartDate(value) {
        this.pasadasStartDate = value;
        this.updatePasadasEndDate(value);
    }
    updatePasadasEndDate(value) {
        this.pasadasEndDate = value;
    }
    updateSelectedDate(value) {
        this.dateSelected = value;
    }
    updateOperator(value) {
        this.operator = value;
    }
    updateWeightCalibrationFactor(value) {
        if (value == null) {
            value = '';
        }
        this.weightCalibrationFactor = value;
    }
    updateWeightCalibrationFactorOriginal(value) {
        if (value == null) {
            value = 0;
        }
        this.weightCalibrationFactorOriginal = value;
    }
    updateHumidityCalibrationFactor(value) {
        if (value == null) {
            value = '';
        }
        this.humidityCalibrationFactor = value;
    }
    updateWorkWidthValue(value) {
        if (value == null) {
            value = '';
        }
        this.workWidthValue = value;
    }
    updateArea(value) {
        if (value == null) {
            value = '';
        }
        this.areaValue = value;
    }
    updateCropTypeValue(value) {
        this.cropTypeValue = value;
    }
    updateDelayValue(value) {
        this.delay = value;
    }
    updateCropTypeRV(value) {
        this.cropTypeRV = value;
    }
    updateFunctionSelected(calibrationSelected) {
        this.calibrationFunctionSelected = calibrationSelected;
        this.setDecalibrateOption(calibrationSelected);
        this.preselectHumidityAndPerformance();
    }
    updateFunctionSelectedRV(value) {
        this.calibrationFunctionSelectedRV = value;
    }
    updateHumidity(value) {
        this.humiditySelected = value;
    }
    updateDescalibrateOption(value) {
        this.decalibrate = value;
    }
    updateHumidityRV(value) {
        this.humidityRV = value;
    }
    updateWeightVariable(value) {
        this.weightVariable = value;
    }
    updateWeightVariableRV(value) {
        this.weightVariableRV = value;
    }
    updateManuallyChecked(value) {
        this.manuallyChecked = value;
    }
    updateComments(value) {
        this.comments = value;
    }
    updateWithouthTelemetry(value) {
        this.withoutTelemetry = value;
    }

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    setDecalibrateOption(calibrationSelected) {
        if (
            calibrationSelected &&
            calibrationSelected['id'] !== this.calibrationsTypes['desdeContador'] &&
            !this.saveOnMemory
        ) {
            this.updateDescalibrateOption(true);
        } else {
            this.updateDescalibrateOption(false);
        }
    }

    preselectHumidityAndPerformance() {
        // console.clear();
        this.updateWeightVariable(null);
        this.updateHumidity(null);
        let self = this;
        if (!this.isPatch) {
            if (this.variablesEnabled.length > 0) {
                let functionSelected =
                    this.calibrationFunctionSelected !== null ? this.calibrationFunctionSelected['id'] : null;
                // console.log("funcion seleccionada: ", functionSelected);
                let keiToFilter = '';
                switch (functionSelected) {
                    case self.calibrationsTypes['multiplicador']:
                        keiToFilter = 'performance';
                        break;
                    case self.calibrationsTypes['flujo']:
                        keiToFilter = 'bean_flow';
                        break;
                    case self.calibrationsTypes['desdeContador']:
                        keiToFilter = 'accumulated_volume';
                        break;
                }
                // console.log("variables habilitadas", this.variablesEnabled);
                // console.log("filtro por key:", keiToFilter);
                let filteredHumidityVariables = JSON.parse(JSON.stringify(this.variablesEnabled)).filter(function(
                    item
                ) {
                    return item['description'] === 'humidity';
                });
                let filteredPerformanceVariables = JSON.parse(JSON.stringify(this.variablesEnabled)).filter(function(
                    item
                ) {
                    return item['description'] === keiToFilter;
                });
                // console.log("variables filtradas rendimiento", filteredPerformanceVariables)
                // console.log("variables filtradas humedad", filteredHumidityVariables);
                if (filteredPerformanceVariables.length !== 0) {
                    let sortedPerformanceVariables = this.getVariablesSortedByVariableId(filteredPerformanceVariables);
                    // console.log("variables ordenadas rendimiento", sortedPerformanceVariables)
                    this.updateWeightVariable(sortedPerformanceVariables[0]);
                }
                if (filteredHumidityVariables.length !== 0) {
                    let sortedHumidityVariables = this.getVariablesSortedByVariableId(filteredHumidityVariables);
                    this.updateHumidity(sortedHumidityVariables[0]);
                    //  console.log("variables ordenadas humedad", sortedHumidityVariables);
                }
            }
        }
    }

    getVariablesSortedByVariableId(variables) {
        return variables.sort(function(a, b) {
            return b['variable_id'] - a['variable_id'];
        });
    }

    parseNumber(value, decimals?) {
        if (decimals) {
            return parseFloatNumber(value, decimals);
        } else {
            return parseFloatNumber(value);
        }
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    get isWithoutTelemetry() {
        return !this.withoutTelemetry ? false : true;
    }

    get calibrationFunctionWasSelected() {
        return this.calibrationFunctionSelected !== null ? true : false;
    }

    get showDecalibrateButton() {
        if (
            this.calibrationFunctionWasSelected &&
            this.calibrationFunctionSelected && this.calibrationFunctionSelected.id !== this.calibrationsTypes['desdeContador'] &&
            !this.saveOnMemory
        ) {
            if (!this.isPatch) {
                this.updateDescalibrateOption(true);
            }
            return true;
        }
        if (!this.isPatch) {
            this.updateDescalibrateOption(false);
        }
        return false;
    }

    getData(): Calibration {
        return {
            operator: this.operator,
            location: null,
            delay: getNumberFormat(this.delay),
            harvest_type: getStringValueFromCombobox(this.cropTypeValue),
            work_width: getNumberFormat(this.workWidthValue),
            vehicle_id: this.vehicleID,
            function: this.calibrationFunctionSelected !== null ? this.calibrationFunctionSelected.id : '',
            date: this.getCalibrationDate(),
            humidity_variable: this.getValuesForVariableSelected(this.humiditySelected),
            weight_variable: this.getValuesForVariableSelected(this.weightVariable),
            weight_calibration_factor: this.getValuesForCalibrationFactors(this.weightCalibrationFactor),
            humidity_calibration_factor: this.getValuesForCalibrationFactors(this.humidityCalibrationFactor),
            comments: this.comments,
            calibration_passes: this.getPasadasListFormatted(),
            active_calibration: this.isPatch ? this.manuallyChecked : true,
            force_no_telemetry: this.isWithoutTelemetry,
            ...(this.showDecalibrateButton ? { decalibrate: this.decalibrate } : {}),
            //si NO es simulador envio el ID sino genero un ID unico necesario para la tabla
            ...(this.saveOnMemory ? { id: this.patchData !== null ? this.patchData['id'] : getUniqueId() } : {})
        };
    }
    getValuesForVariableSelected(variableSelected: selectedOptionWithDescription): null | number {
        return this.isWithoutTelemetry || variableSelected == null ? null : getNumberFormat(variableSelected.id);
    }

    getValuesForCalibrationFactors(calibrationFactor:string){
        return calibrationFactor === '' ? null : getNumberFormat(calibrationFactor)
    }

    getCalibrationDate():DateTimeField {
        let date = this.dateSelected;
        //le agrego las horas y minutos seleccionados
        date += this.calibrationHour;
        return moment(date, dateTypes.globalFilterDateFormatNoSeconds).format(dateTypes.globalFilterDateFormat);
    }
    
    parseValuesForPasada(value: string): null | number{
        return valueIsEmpty(value) ? null : Number(this.parseNumber(value))
    }

    getPasadasListFormatted():CalibrationPass[] {
        let self = this;
        let pasadasList  = JSON.parse(JSON.stringify(this.itemsPasadas));
        for (let index = 0; index < pasadasList.length; index++) {
            let pasada = pasadasList[index];
            pasada['measured_humidity'] = self.parseValuesForPasada(pasada['measured_humidity'])
            pasada['humidity'] = self.parseValuesForPasada(pasada['humidity'])
            pasada['measured_weight'] = self.parseValuesForPasada(pasada['measured_weight'])
            pasada['weight'] = self.parseValuesForPasada(pasada['weight'])
            pasada = getJsonObjectWithoutSomeKeys(pasada, [
                'rinde_medido',
                'rinde_maquina',
                'pending',
                'hour_start',
                'hour_end'
            ])
            if (typeof pasada['id'] === 'string') {
                delete pasada['id'];
            }
            if (pasada['start_date'].indexOf('T') == -1) {
                pasada['start_date'] += 'T00:00:00';
            }
            if (pasada['end_date'].indexOf('T') == -1) {
                pasada['end_date'] += 'T23:59:00';
            }
        }
        return pasadasList;
    }

    seePasadaInTravel(item) {
        openTravelWithParameter(item['start_date'], item['end_date'], [this.vehicleID], this.companies[0]['id']);
    }

    get allCalibrationPassesAreNotApplied() {
        if (this.itemsPasadas.length === 0) {
            return true; 
        }

        for (const item of this.itemsPasadas) {
            if (!item.hasOwnProperty('active_calibration_pass') || item['active_calibration_pass'] !== false) {
                return false; 
            }
        }
        return true;
    }

    get formIsValid() {
        this.updateErrorForm('');
        if (this.dateSelected == null) {
            this.updateErrorForm('Debe seleccionar una fecha');
            return false;
        }
        if (this.operator === '') {
            this.updateErrorForm('Debe ingresar un maquinista');
            return false;
        }
        if (this.cropTypeValue == null) {
            this.updateErrorForm('No ingresó tipo de cultivo');
            return false;
        }
        if (!this.calibrationFunctionWasSelected) {
            this.updateErrorForm('No seleccionó funcion de calibración');
            return false;
        }
        if (
            this.isWithoutTelemetry &&
            this.calibrationFunctionSelected && this.calibrationFunctionSelected.id === this.calibrationsTypes['desdeContador']
        ) {
            this.updateErrorForm('Ignorar telemetría no admite funcion de volumen');
            return false;
        }
        if (this.humiditySelected == null && !this.isWithoutTelemetry) {
            this.updateErrorForm('No seleccionó variable de humedad');
            return false;
        }
        if (this.weightVariable == null && !this.isWithoutTelemetry) {
            this.updateErrorForm('No seleccionó variable de rendimiento');
            return false;
        }
        if (this.delay === '') {
            this.updateErrorForm('Falta ingresar valor de Delay');
            return false;
        }
        if (this.itemsPasadas.length == 0) {
            this.updateErrorForm('Debe ingresar al menos una pasada de calibración');
            return false;
        }
        if (this.workWidthValue === '') {
            this.updateErrorForm('Falta ingresar ancho de trabajo');
            return false;
        }
        return true;
    }

    updateErrorForm(value) {
        this.errorMsg = value;
    }

    @Emit()
    closeModal() {}

    @Emit()
    addNewCalibration(item) {
        return item;
    }

    @Emit()
    patchCalibration(item) {
        return item;
    }

    @Emit()
    reloadMachineDetail() {}

    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.assignPropertiesData();
            self.loadPatchData();
        });
    }

    assignPropertiesData() {
        let self = this;
        this.calibrationOptions = this.$_getInsuranceProperties['calibration_functions'].filter(
            item =>
                item['id'] == self.calibrationsTypes['desdeContador'] ||
                item['id'] === self.calibrationsTypes['multiplicador'] ||
                item['id'] === self.calibrationsTypes['flujo']
        );
    }

    get isPatch() {
        return this.patchData !== null ? true : false;
    }

    saveCalibration() {
        let data:Calibration = this.getData();
        // console.log("save calibration", data);
        if(this.saveOnMemory){
            //Si es simulador
            //humedad y peso las preciso como objeto para la tabla
            let simulatedCalibration:CalibrationSimulated = {
                ...data,
                humidity_variable: this.humiditySelected,
                weight_variable:  this.weightVariable,
                forced_no_telemetry: data['force_no_telemetry'],
            }

            if(this.allCalibrationPassesAreNotApplied){
                //en simulador no hay WS de respuesta por eso actualizo a mano
                //si se aplica o no
                simulatedCalibration['active_calibration'] = false;
            }

            if (!this.isPatch) {
                //Guardar nueva calibracion en memoria
                 this.addNewCalibration(simulatedCalibration);
            }else{
                //Modifico calibracion en memoria en simulador
                this.patchCalibration(simulatedCalibration);
            }
            this.closeModal();
        }else{
            //Si NO es simulador
            if (!this.isPatch) {
                //Envio nueva calibracion a backend
                this.postCalibration(data);
            }else{
                //Envio a modificar calibracion a backend
                this.modifyCalibration(data)
            }
        }
    }

    postCalibration(data) {
        this.showLoadingDialog('Guardando Calibración...');
        InsuranceServices.postCalibration(data)
            .then(res => {
                this.showTelemetryError(res['using_telemetry']);
                this.showSuccessLoadingDialog(res, 'Calibración creada con éxito');
                this.addNewCalibration(res);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo guardar la calibración');
            });
    }

    showTelemetryError(usingTelemetry) {
        if (usingTelemetry == false) {
            this.$_showHistoricalError(
                'No se pueden usar los datos de telemetría para generar el factor de calibración, se tomarán los relevados de la máquina'
            );
        }
    }

    modifyCalibration(data) {
        this.showLoadingDialog('Modificando Calibración...');
        let self = this;
        if (this.patchData) {
            let calibrationId = this.patchData['id'];
            InsuranceServices.patchCalibration(data, calibrationId)
                .then(response => {
                    if (this.patchData && this.patchData['decalibration_applied'] !== undefined) {
                        if (this.patchData['decalibration_applied'] !== response['data']['decalibration_applied']) {
                            this.reloadMachineDetail();
                        }
                    }
                    self.showTelemetryError(response['data']['using_telemetry']);
                    self.patchCalibration(response['data']);
                    self.showSuccessLoadingDialog(response.data, 'Calibración Modificada con éxito');
                })
                .catch(err => {
                    self.showCatchLoadingDialog(err, 'No se pudo modificar la calibración');
                });
        }
    }

    loadPatchData() {
        if (this.isPatch) {
            this.modalTitle = 'Modificar Calibración';
        } else {
            this.modalTitle = 'Agregar Nueva Calibración';
        }
        if (this.isPatch && this.patchData !== null) {
            this.updateDelayValue(this.patchData['delay']);
            this.updateSelectedDate(this.patchData['date']);
            this.setCalibrationHour(this.patchData['date']);
            this.updateOperator(this.patchData['operator']);
            this.setSelectedFunction(this.patchData['function']);
            this.updateWithouthTelemetry(this.patchData['forced_no_telemetry']);
            this.setCropType(this.patchData['harvest_type']);
            this.updateHumidityCalibrationFactor(this.patchData['humidity_calibration_factor']);
            this.updateWeightCalibrationFactor(this.patchData['weight_calibration_factor']);
            this.updateWeightCalibrationFactorOriginal(this.patchData['weight_calibration_factor']);
            this.setHumidityVariable(this.patchData['humidity_variable']);
            this.updateWorkWidthValue(this.patchData['work_width']);
            this.updateWeightVariable(this.patchData['weight_variable']);
            this.setCalibrationPasadas(this.patchData['calibration_passes']);
            this.updateManuallyChecked(this.patchData['active_calibration']);
            this.updateDescalibrateOption(this.patchData['decalibration_applied']);
            this.updateComments(this.patchData['comments']);
        } else {
            this.setNewestDelayValue();
            this.updateCalibrationHour('00:00');
            this.setDateWithCurrentTimestamp();
            this.setWorkWidthWithMostRecentPasadasValue();
        }
    }

    setNewestDelayValue(){
        let newestCalibration = this.getNewestCalibrationIndexFromList();
        if(newestCalibration !== -1){
            this.updateDelayValue(this.calibrations[newestCalibration]['delay']);
        }else{
            this.updateDelayValue(Number(this.defaultDelay))
        }
    }

    setDateWithCurrentTimestamp() {
        let currentTimestamp = getCurrentTimestamp(dateTypes.dateYearFormatReverse);
        this.updateSelectedDate(currentTimestamp);
    }

    setWorkWidthWithMostRecentPasadasValue() {
        let newestCalibration = this.getNewestCalibrationIndexFromList();
        if(newestCalibration !== -1){
             this.updateWorkWidthValue(this.calibrations[newestCalibration]['work_width']);
        }
    }

    getNewestCalibrationIndexFromList(){
        let calibrationIndex = -1;
        if(this.calibrations.length !== 0){
            let getMaxDate = getMaxDateFromList(this.calibrations, 'date');
            if (getMaxDate !== null) {
                calibrationIndex = this.calibrations.findIndex(item => item['date'] === getMaxDate);
            }
        }
        return calibrationIndex
    }

    setCalibrationHour(date) {
        this.updateCalibrationHour(splitStringByIndex(date, 11, date.length - 3));
    }

    setCalibrationPasadas(calibrationPasses) {
        calibrationPasses.forEach(pasada => {
            // console.log("pasada", pasada);
            pasada['pending'] = false;
            pasada['rinde_maquina'] = this.getRindeFromWeightAndArea(pasada['measured_weight'], pasada['area']);
            pasada['rinde_medido'] = this.getRindeFromWeightAndArea(pasada['weight'], pasada['area']);
            pasada['humidity_enabled'] = pasada['humidity'] && pasada['measured_humidity'] !== null ? true : false
            pasada['weight_enabled'] = pasada['weight'] && pasada['measured_weight'] !== null ? true : false
        });
        this.itemsPasadas = calibrationPasses;
    }

    getRindeTelemetryValue(element) {
        // console.log('element', element);
        let self = this;
        let value: any = null;
        let calculated_weight = element['calculated_weight'] ? element['calculated_weight'] : 0;
        if (this.calibrationFunctionSelected !== null) {
            switch (this.calibrationFunctionSelected['id']) {
                case self.calibrationsTypes['multiplicador']:
                case self.calibrationsTypes['flujo']:
                    // console.log('rinde telemetria es calculated_weight', element['calculated_weight']);
                    value = calculated_weight;
                    break;
                case self.calibrationsTypes['desdeContador']:
                    // console.log(
                    //     'rinde telemetria es (calculated_weight * factor ORIGINAL de calibracion de peso)  / area (',
                    //     element['calculated_weight'] +
                    //         ' * ' +
                    //         this.weightCalibrationFactorOriginal +
                    //         ')' +
                    //         ' /' +
                    //         element['area']
                    // );
                    value =
                        element['area'] !== 0 && element['area'] !== null
                            ? (calculated_weight * this.weightCalibrationFactorOriginal) / element['area']
                            : 0;
                    break;
            }
        }
        if (value !== null && value !== 0) {
            value = parseFloatNumber(value);
        }
        return value;
    }

    setSelectedFunction(kei: string) {
        let indexKeiInList = this.calibrationOptions.findIndex(item => item['id'] === kei);
        if (indexKeiInList !== -1) {
            this.updateFunctionSelected(this.calibrationOptions[indexKeiInList]);
        }
    }

    dateFormatter(value) {
        if (!moment(value).isValid()) {
            return '-';
        } else {
            return formatDate(value);
        }
    }

    setCropType(value: string) {
           let indexKeiInList = this.cropTypes.findIndex(item => item['value'] === value);
           if(indexKeiInList !== -1){
               this.updateCropTypeValue(this.cropTypes[indexKeiInList]);
           }
    }

    setHumidityVariable(item: object) {
        if (item && item['id']) {
            this.updateHumidity(item);
        }
    }

    getRindeFromWeightAndArea(pesoMaquina, areaMaquina) {
        let defaultValue = '';
        if(pesoMaquina === '' || areaMaquina === ''){
          return defaultValue
        }
        if (!isNaN(pesoMaquina) && !isNaN(areaMaquina)) {
            if (areaMaquina !== 0 && areaMaquina !== null) {
                return Number(parseFloatNumber(pesoMaquina / areaMaquina));
            }
            return 0;
        }
    }

    editPasada(item) {
        this.pasadasHumidity = item['humidity'];
        this.pasadasWeight = item['weight'];
        this.pasadasCalculatedWeight = item['calculated_weight'];
        this.pasadasMeasuredHumidity = item['measured_humidity'];
        this.pasadasMeasuredWeight = item['measured_weight'];
        this.pasadasHumidityEnabled = item['humidity_enabled'];
        this.pasadasWeightEnabled = item['weight_enabled'];
        this.pasadasArea = item['area'];
        item['rinde_medido'] = this.getRindeFromWeightAndArea(this.pasadasMeasuredWeight, this.pasadasArea);
        item['rinde_maquina'] = this.getRindeFromWeightAndArea(this.pasadasMeasuredWeight, this.pasadasArea);
        this.pasadasStartDate = item['start_date'];
        this.pasadasEndDate = item['end_date'];
        this.pasadasStartHour = this.getHourValueFromTimestamp(item['start_date'], true);
        this.pasadasEndHour =  this.getHourValueFromTimestamp(item['end_date'], false);
        this.editedIndex = this.itemsPasadas.indexOf(item);
        this.editedItem = Object.assign({}, item);
    }

    resetPasadasValues() {
        this.editedIndex = -1;
        this.pasadasHumidity = '';
        this.pasadasWeight = '';
        this.pasadasCalculatedWeight = '';
        this.pasadasMeasuredHumidity = '';
        this.pasadasMeasuredWeight = '';
        this.pasadasHumidityEnabled = false;
        this.pasadasWeightEnabled = false;
        this.pasadasArea = '';
        this.pasadasStartDate = '';
        this.pasadasEndDate = '';
        this.pasadasStartHour = '';
        this.pasadasEndHour = '';
        this.editedItem = {
            id: -1,
            humidity: '',
            weight: '',
            measured_humidity: '',
            measured_weight: '',
            calculated_weight: null,
            start_date: '',
            humidity_enabled: false,
            weight_enabled: false,
            end_date: '',
            hour_start: '',
            hour_end: '',
            area: ''
        };
    }

get canSaveNewPasada() {
        //Validacion de pasada de calibracion
        console.log("Validacion de pasada de calibracion");
        if(
            this.pasadasStartDate == null || this.pasadasStartDate === '' ||
            this.pasadasEndDate == null || this.pasadasEndDate === ''
         ){
            //es necesario una fecha de inicio y fin
            return false
        }
        
        if(valueIsEmpty(this.pasadasArea)){
            //es necesario el area
            return false
        }

        if(this.pasadasHumidityEnabled){
            //si se marca el checkbox de Humedad
            //measured_humidity y humidity tienen que estar completos
            if(valueIsEmpty(this.pasadasMeasuredHumidity) || valueIsEmpty(this.pasadasHumidity)){
                return false
            }
        }
        
        if(this.pasadasWeightEnabled){
            //si se marca el checkbox de Peso
            //measured_weight y weight tienen que estar completos
            if(valueIsEmpty(this.pasadasMeasuredWeight) || valueIsEmpty(this.pasadasWeight)){
                return false
            }
        }

        return true;
    }

    deleteItem(item) {
        const index = this.itemsPasadas.indexOf(item);
        if (index !== -1) {
            this.itemsPasadas.splice(index, 1);
        }
    }

    labelVariableSelector(option) {
        let description = option.description == null ? ' ' : option.description;
        return `${option.variable_id} - ${description}`;
    }

    close(item) {
        setTimeout(() => {
            if (item['pending'] == true) {
                this.deleteItem(this.itemsPasadas[0]);
            } else {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
            this.waitingPasada = false;
            this.resetPasadasValues();
        }, 300);
    }

    getHourValueFromTimestamp(value:string, isStart:boolean){
        let defValue = isStart ? '00:00' : '23:59';
        return value !== '' ? getHourFromTimestamp(value) : defValue
    }

    addNewPasada() {
        
        let preselectedDate = this.dateSelected !== null ? this.dateSelected : '';
        let startDate = preselectedDate !== '' ? preselectedDate + 'T00:00:00' : ''
        let endDate = preselectedDate !== '' ? preselectedDate + 'T23:59:00' : '';
        let startHour = this.getHourValueFromTimestamp(startDate, true);
        let endHour = this.getHourValueFromTimestamp(endDate, false);
        this.itemsPasadas.unshift({
            id: getUniqueId(),
            humidity: '',
            weight: '',
            measured_weight: '',
            calculated_weight: 0,
            measured_humidity: '',
            humidity_enabled: true,
            active_calibration_pass: true,
            weight_enabled: true,
            performance_calibration_factor: '',
            humidity_calibration_factor: '',
            start_date: startDate,
            end_date: endDate,
            hour_start: startHour,
            hour_end: endHour,
            area: '',
            pending: true
        });
        this.waitingPasada = true;
        this.editPasada(this.itemsPasadas[0]);
    }

    getNumberOrEmpty(value){
        return isNaN(value) ? '' : this.parseNumber(value, 7)
    }

    getNumberOrNull(value){
        return value === "" ? null : this.parseNumber(value, 7)
    }

    savePasada() {
        this.waitingPasada = false;
        if (this.editedIndex > -1) {
            this.editedItem['pending'] = false;
            this.editedItem['humidity'] = this.getNumberOrEmpty(this.pasadasHumidity);
            this.editedItem['weight'] = this.getNumberOrEmpty(this.pasadasWeight);
            this.editedItem['calculated_weight'] = Number(this.pasadasCalculatedWeight);
            this.editedItem['measured_weight'] = this.getNumberOrEmpty(this.pasadasMeasuredWeight);
            this.editedItem['measured_humidity'] = this.getNumberOrEmpty(this.pasadasMeasuredHumidity);
            this.editedItem['humidity_enabled'] = this.pasadasHumidityEnabled;
            this.editedItem['weight_enabled'] = this.pasadasWeightEnabled;
            this.editedItem['area'] = Number(this.pasadasArea);

            this.editedItem['rinde_maquina'] = this.getRindeFromWeightAndArea(
                this.editedItem['measured_weight'],
                this.editedItem['area']
            );
            this.editedItem['rinde_medido'] = this.getRindeFromWeightAndArea(
                this.editedItem['weight'],
                this.editedItem['area']
            );

            let startDate = moment(this.pasadasStartDate, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let startHour = this.pasadasStartHour;

            let endDate = moment(this.pasadasEndDate, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let endHour = this.pasadasEndHour;

            this.editedItem['start_date'] = startDate + 'T' + startHour;
            this.editedItem['end_date'] = endDate + 'T' + endHour;

            let periodIsValid = checkOverlapPeriod(this.itemsPasadas, this.editedItem, this.editedIndex);
            let differenceBetweenDatesIsValid = differenceBetweenTwoDatesIsValid(
                this.editedItem['start_date'],
                this.editedItem['end_date'],
                1
            );

            if (typeof periodIsValid === 'string') {
                this.$_showHistoricalError(periodIsValid);
            } else {
                if (!differenceBetweenDatesIsValid) {
                    this.$_showHistoricalError('Las pasadas no pueden durar más de 1 día');
                } else {
                    Object.assign(this.itemsPasadas[this.editedIndex], this.editedItem);
                    this.resetPasadasValues();
                }
            }
        }
    }
}
